//Header Component

import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'text-white border-b-2 border-white' : 'text-teal-100 hover:text-white';
  };

  return (
    <header className="header p-4 bg-teal-600 text-white shadow-lg">
      <div className="w-full mx-auto px-6"  style={{ maxWidth: "1400px" }}>
        <div className="flex justify-between items-center">
          <Link to="/">
            <h1 className="text-xl font-semibold">PSpace</h1>
            <p className="text-sm font-light">Your Gateway to AI Planning Software</p>
          </Link>
          
          {/* Navigation Menu */}
          <nav className="flex gap-8">
            <Link
              to="/"
              className={`font-semibold transition-colors pb-2 ${isActive('/')}`}
            >
              Home
            </Link>
            <Link
              to="/discover"
              className={`font-semibold transition-colors pb-2 ${isActive('/discover')}`}
            >
              Discover
            </Link>
            <Link
              to="/knowledge-graph"
              className={`font-semibold transition-colors pb-2 ${isActive('/knowledge-graph')}`}
            >
              Knowledge Graph
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
